export const ERROR_STATUS_UPDATE = 'overview/ERROR_STATUS_UPDATE';
export const DOWNLOAD_LOGGER = 'eventlist/assistance/DOWNLOAD_LOGGER';
export const CLEAR_LOGGER_FILE = 'eventList/assistance/CLEAR_LOGGER_FILE';
export const DATA_LOGGER = 'DataLogger';
